module.exports = __webpack_public_path__ + "static/media/atom.dba14ceb.svg";